export default "__VITE_ASSET__qY9r4yrB__"